import axios from "axios";
import {
    SHOPPERS_API_URL,
    SHOPPER_API_URL,
    PAGINAS_SHOPPER_API_URL,
    PAGINA_SHOPPER_API_URL,
    PRODUCTS_BY_SHOPPER_API_URL
} from "./URL";

export const getShoppers = async () => {
    const params = {}
    params[`populate[0]`] = 'pdf'
    params[`populate[1]`] = 'imagenPrincipal'
    params[`sort[0]`] = 'orden:asc'
    return axios.get(SHOPPERS_API_URL, {
        params: params
    })
}

export const getShopper = async (shopperSlug) => {
    const params = {}
    params[`filters[slug][$eq]`] = shopperSlug
    // No filtrar por mostrarEnHome aquí, dejar que el backend devuelva el shopper si existe
    params[`populate[0]`] = 'pdf'
    params[`populate[1]`] = 'imagenPrincipal'
    params[`populate[2]`] = 'filtros'
    params[`populate[3]`] = 'video'
    return axios.get(SHOPPERS_API_URL, {
        params: params
    })
}

export const getProductsShopperBySearch = async (prodSearch, shopId, filtros, pagIndex, limit) => {
    console.log('ParamsBusqueda:', prodSearch, 'PagIndex', pagIndex)
    const params = {}
    params[`filters[shopper][id][$eq]`] = shopId
    params[`pagination[start]`] = pagIndex
    params[`pagination[limit]`] = limit
    if (prodSearch.length > 0) {
        params[`search`] = prodSearch
    }
    if (filtros && Array.isArray(filtros)) {
        filtros.forEach((filtro) => {
            if (filtro.seleccionados && Array.isArray(filtro.seleccionados)) {
                let nombre = ''
                switch (filtro.filtro) {
                    case 'Tipo de juguete':
                        nombre = 'tipos'
                        break;
                    case 'Edad':
                        nombre = 'edades'
                        break;
                    default:
                        nombre = ''
                }
                filtro.seleccionados.forEach((seleccionado, index) => {
                    params[`${nombre}[${index}]`] = seleccionado
                })
            }
        })
    }

    return axios.get(PRODUCTS_BY_SHOPPER_API_URL, {
        params: params
    })
}

export const getPaginasShopperByShopperSlug = async (shopperSlug) => {
    const params = {}
    params[`filters[shopper][slug][$eq]`] = shopperSlug
    params[`populate[0]`] = 'imagen'
    params[`populate[1]`] = 'productos.imagenes'
    params[`populate[2]`] = 'productos.tipos'
    params[`populate[3]`] = 'productos.edades'
    params[`populate[4]`] = 'productos.cta'
    params[`sort[0]`] = 'numeroPagina:asc'
    params['pagination[page]'] = 1
    params['pagination[pageSize]'] = 100
    return axios.get(PAGINAS_SHOPPER_API_URL, {
        params: params
    })
}

export const getPagina = async (paginaId) => {
    const params = {}
    params[`populate[0]`] = 'imagen'
    params[`populate[1]`] = 'productos'
    return axios.get(PAGINA_SHOPPER_API_URL.replace(':paginaId', paginaId), {
        params: params
    })
}
